  <!-- 客户档案 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" @moreHandle="topCommandBtns" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore">
      <template slot="time1">
        <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
      </template>
    </input-plug>
    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" ref="mytable" @rowCallback="rowCallback" @selectChange="handleSelectionChange" @jumpPage="goYdDetails" />
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    /> <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true" @changeCallback="rowCallback">
        <template slot="time1">
          <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
        </template>
      </input-plug>
    </exportCompoent>
  </div>
</template>
  <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1,exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "客户档案", //导出时默认文件名
        apiName: "/admin/v3/tms/customer/getCustomerList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "新增",
          method: "addClick",
          permissVal: "admin:customer:addCustomer",
        },
        {
          name: "修改",
          method: "modifyClick",
          permissVal: "admin:customer:udpateCustomer",
        },
        {
          name: "删除",
          method: "delete",
          permissVal: "admin:customer:delCustomer",
        },
        {
          name: "审核",
          method: "examine",
          permissVal: "admin:customer:examineCustomer",
        },
        {
          name: "反审核",
          method: "deApprove",
          permissVal: "admin:customer:reExamineCustomer",
        },
        {
          name: "报价设置",
          method: "quotationSettings",
          // permissVal: "aaaaa",
        },
        {
          type: true,
          name: "更多操作",
          options: [
            {
              handleName: "dc",
              label: "导出",
            },
            {
              handleName: "bgsz",
              label: "表格设置",
            },
          ],
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "timeSelect",
          slotName: "time1",
        },
        {
          type: "input",
          label: "客户名称",
          field: "customerName",
          placeholder: "请输入",
        },

        {
          type: "select",
          label: "所属网点",
          field: "deptId",
          placeholder: "请选择",
          setLabel: "departmentName",
          setValue: "deptId",
          selectOptions: [],
        },
        {
          type: "select",
          label: "审核状态",
          field: "approveStatus",
          placeholder: "请选择",
          selectOptions: [
            { label: "审核中", val: "shen_he_zhong:approve_status" },
            { label: "审核通过", val: "tong_guo:approve_status" },
            { label: "审核拒绝", val: "ju_jue:approve_status" },
          ],
        },
      ],

      queryData: {
        approveStatus: null,
        customerName: null,
        deptId: null,
        endCreateTime: null,
        startCreateTime: null,
      },
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "创建日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "操作",
          field: "edit",
          width: 220,
          Buttons: [
            {
              method: "modifyClick",
              methodName: "修改",
              permissVal: "admin:customer:udpateCustomer",
            },
            {
              method: "delete",
              methodName: "删除",
              permissVal: "admin:customer:delCustomer",
            },
            {
              method: "examine",
              methodName: "审核",
              permissVal: "admin:customer:examineCustomer",
            },
            {
              method: "deApprove",
              methodName: "返审核",
              permissVal: "admin:customer:reExamineCustomer",
            },
          ],
        },
        {
          name: "所属网点",
          field: "deptName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户编号",
          field: "customerNumber",
          sort: 4,
          isShow: true,
          isSort: true,
        },
        {
          name: "客户名称",
          field: "customerName",
          sort: 5,
          isShow: true,
        },
        {
          name: "审核状态",
          field: "approveStatusShow",
          sort: 5,
          isShow: true,
        },
        {
          name: "审核时间",
          field: "approveTime",
          sort: 5,
          isShow: true,
        },
        {
          name: "是否月结",
          field: "isMonthShow",
          sort: 6,
          isShow: true,
        },
        {
          name: "是否厂家运输",
          field: "isFactoryTransportShow",
          sort: 1,
          isShow: true,
        },
        {
          name: "是否停用展示",
          field: "isStopShow",
          sort: 1,
          isShow: true,
        },
        {
          name: "尚欠运费",
          field: "arrearFreight",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "信用额度",
          field: "creditLine",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "业务员",
          field: "salesmanName",
          sort: 18,
          isShow: true,
        },
        {
          name: "付款方式",
          field: "settlementMethod",
          sort: 19,
          isShow: true,
        },
        {
          name: "是否开票",
          field: "isInvoicingShow",
          sort: 1,
          isShow: true,
        },
        {
          name: "开票税点",
          field: "taxPoint",
          sort: 1,
          isShow: true,
        },
        {
          name: "票据类型",
          field: "invoiceType",
          sort: 2,
          isShow: true,
        },
        {
          name: "付款账期",
          field: "paymentPeriod",
          sort: 2,
          isShow: true,
        },
        {
          name: "还款起始日",
          field: "repaymentStartDate",
          sort: 2,
          isShow: true,
        },
        {
          name: "还款结束日",
          field: "repaymentEndDate",
          sort: 2,
          isShow: true,
        },
        {
          name: "联系电话",
          field: "tel",
          sort: 1,
          isShow: true,
        },
        {
          name: "责任人",
          field: "personInCharge",
          sort: 1,
          isShow: true,
        },
        {
          name: "手机号码",
          field: "phone",
          sort: 1,
          isShow: true,
        },
        {
          name: "联系地址",
          MultiAttr: "isFields",
          field: "provinceName",
          width: 260,
          fields: ["provinceName", "cityName", "areaName", "address"],
          sort: 2,
          isShow: true,
        },
        {
          name: "首次开单时间",
          field: "firstOpenBillDate",
          sort: 1,
          isShow: true,
        },
        {
          name: "最后开单时间",
          field: "newestOpenBillDate",
          sort: 180,
          isShow: true,
        },
        {
          name: "未开单天数",
          field: "aaa",
          width: "120",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "开单票数",
          field: "openBillCount",
          sort: 1,
          isShow: true,
        },

        {
          name: "开单总额",
          field: "openBillTotalAmount",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "审核人",
          field: "approveUserName",
          sort: 1,
          isShow: true,
        },
        {
          name: "新增人",
          field: "createUserName",
          sort: 1,
          isShow: true,
        },
        {
          name: "新增时间",
          field: "createTime",
          sort: 1,
          isShow: true,
        },
        {
          name: "备注",
          field: "remarks",
          sort: 1,
          isShow: true,
        },
        {
          name: "修改时间",
          field: "updateTime",
          sort: 1,
          isShow: true,
        },
        {
          name: "修改人",
          field: "updateUserName",
          sort: 1,
          isShow: true,
        },
      ],
      // // 分页
      // pageStart: 1, //  页码
      // pageCount: 0, //  总条数
      // pageTotal: 20, //  一页几条
      // 自定义表头
      // originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      // show_sortTableHeard: false, //显示表格设置弹窗
      // allCheck: false, //  全选
      pageGroupName: "Custom",
      sortName: "客户档案", //  排序名
      // selectLength: 0, //  显示的长度
      // totalArr: [],
      // className: "", //  导出需要
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    // this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    // this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;
    this.GetData();
    this.getDeptList();
  },
  methods: {
    quotationSettings() {
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.$router.push({
          path: "/Customers/CustomCarrierQuotationLC",
          query: {
            customerNumber: this.selectTableData[0].customerNumber,
            customerId: this.selectTableData[0].customerId,
            customerName: this.selectTableData[0].customerName,
          },
        });
      }
    },
    // 获取客户档案列表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.$API.CustomerList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          let _tabledata = res.data.result?.data || [];
          for (let t in _tabledata) {
            let startTime = _tabledata[t].contractStartTime
              ? _tabledata[t].contractStartTime.split(" ")
              : "";
            let endTime = _tabledata[t].contractEndTime
              ? _tabledata[t].contractEndTime.split(" ")
              : "";
            _tabledata[t].contractStartTime = startTime[0];
            _tabledata[t].contractEndTime = endTime[0];
          }
          this.className = res.data.result?.className || "";
          this.tableConfig.tableData = _tabledata;
          this.pageCount = res.data.result?.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---客户档案列表`);
        }
      });
    },

    // 获取查询框网点字段
    getDeptList() {
      this.$API.wtl_getDeptList().then((res) => {
        if (res.data.status === "success") {
          this.baseConfig[2].selectOptions = res.data.result?.data || [];
        } else {
          this.$message.error(`${res.data.message}`);
        }
      });
    },

    // 表格内按钮的回调事件
    rowCallback(data, name) {
      this[name](data);
    },

    // 新增
    addClick() {
      this.$router.push("/Customers/CustomMOD/Create");
    },

    // 修改
    modifyClick(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.$router.push({
          path: "/Customers/CustomMOD/Edit",
          query: {
            customerId: this.selectTableData[0].customerId,
            number: this.selectTableData[0].customerNumber,
          },
        });
      }
    },

    // 删除
    delete(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              customerIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.customerIds.push(val.customerId);
            });
            this.$API.delCustomer(delReq).then((res) => {
              if (res.data.status === "success") {
                this.GetData();
                this.$message.success(res.data.message);
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },

    // 审核
    examine(data, t) {
      if (data) this.selectTableData = [data];
      let msg = "确认要审核通过所选数据？";
      if (t) msg = t;
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm(msg, "提示:")
          .then((res) => {
            let params = {
              customerIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              params.customerIds.push(val.customerId);
            });

            if (t) {
              // 翻审核接口
              this.$API.reExamineCustomer(params).then((r) => {
                if (r.data.status === "success") {
                  this.GetData();
                  this.$message.success(r.data.message);
                }
              });
            } else {
              // 审核接口
              this.$API.examineCustomer(params).then((e) => {
                if (e.data.status === "success") {
                  this.GetData();
                  this.$message.success(e.data.message);
                }
              });
            }
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },

    // 反审核
    deApprove(data) {
      this.examine(data, "确认要把所选数据返审核？");
    },

    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableConfig.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },
    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dybq") {
        // 打印标签
      }
      if (a === "dr") {
        // 导入
      }
      if (a === "dc") {
        // 导出
        // this.exportBtn();
        this.isShowDialog_dc = true;
      }
    },

    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.startTime_a = "";
      this.endTime_a = "";
      this.GetData();
    },

    // 时间查询框选择时间时的事件
    queryBtn_time(t1, t2) {
      this.startTime_a = t1;
      this.endTime_a = t2;
      if (t1 && t2) {
        this.GetData();
      }
    },

    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },

    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },

    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },
  },
};
</script>
  <style scoped lang="less">
</style>
  